import React from 'react';
import Login from './Login';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import VehicleList from './components/VehicleList';
import VehicleDetail from './components/VehicleDetail';
import HealthPanel from './components/HealthPanel';
import AdminUsers from './components/AdminUsers';
import { getUser, setUser, setToken, removeUser } from './util/storage';
import { getFlagsSnapshot, subscribeFlags, wireUserContext, refreshFlags } from './flags';
import useRoxFlag from './hooks/useRoxFlag';

function App() {
  const [user, setUserState] = React.useState(() => getUser());
  const [view, setView] = React.useState('dashboard'); // dashboard | vehicles | vehicle-detail | health | admin-users
  const [selectedVehicleId, setSelectedVehicleId] = React.useState(null);

  // FM flags snapshot
  const [flagSnap, setFlagSnap] = React.useState(() => getFlagsSnapshot() || {});
  React.useEffect(() => subscribeFlags((_reason, snap) => setFlagSnap(snap || {})), []);

  // Wire user context for FM targeting on mount
  React.useEffect(() => {
    try { wireUserContext(); } catch {}
  }, []);

  const isLoggedIn = !!user;
  const showHealthPanel = useRoxFlag('showHealthPanel');
  const adminUsers = useRoxFlag('adminUsers');
  const isAdmin = user?.roles?.includes('admin');

  const handleLogin = (loginData) => {
    setUser(loginData);
    setToken(loginData.token);
    setUserState(loginData);
    setView('dashboard');

    // Refresh FM flags after login for user-targeted flags
    try {
      wireUserContext();
      refreshFlags();
    } catch {}
  };

  const handleLogout = () => {
    removeUser();
    setUserState(null);
    setView('dashboard');

    // Refresh FM flags after logout
    try {
      wireUserContext();
      refreshFlags();
    } catch {}
  };

  const handleViewVehicle = (vehicleId) => {
    setSelectedVehicleId(vehicleId);
    setView('vehicle-detail');
  };

  const handleBackToList = () => {
    setSelectedVehicleId(null);
    setView('vehicles');
  };

  if (!isLoggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app">
      <Header
        user={user}
        onLogout={handleLogout}
        view={view}
        setView={setView}
        showHealthPanel={showHealthPanel}
        showAdminUsers={adminUsers && isAdmin}
        welcomeMessage={flagSnap?.welcomeMessage}
      />
      <div className="main-content">
        {view === 'dashboard' && <Dashboard setView={setView} />}
        {view === 'vehicles' && <VehicleList onViewVehicle={handleViewVehicle} />}
        {view === 'vehicle-detail' && (
          <VehicleDetail vehicleId={selectedVehicleId} onBack={handleBackToList} />
        )}
        {view === 'health' && showHealthPanel && <HealthPanel />}
        {view === 'admin-users' && adminUsers && isAdmin && <AdminUsers />}
      </div>
    </div>
  );
}

export default App;
